var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c(_vm.componentToLoad,{tag:"component"})],1),_c('div',{staticClass:"common-background__svg"},[_c('img',{attrs:{"src":_vm.backgroundImage}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }